import { Progress } from "antd";

interface ProgressItemCardProps {
    title: string;
    description: string;
    percent: number;
}

const ProgressItemCard = ({
    title,
    description,
    percent,
}: ProgressItemCardProps) => {
    return (
        <div className="custom-page-css flex flex-col pt-2">
            <span className='font-regular text-white text-sm'>{title}</span>
            <span className='font-regular text-white text-sm'> {description}</span>

            <Progress
                percent={percent}
                showInfo={false}
                strokeColor={{
                    "0%": "#1890FF",
                    "100%": "#b6d8f8",
                }}
                strokeWidth={10}
                trailColor="#F5F5F5"
                strokeLinecap="round"
            />
        </div>
    );
};

export default ProgressItemCard